import React from 'react';
import { ContentHeading } from './ContentHeading/ContentHeading';
import { ContentBanner } from './ContentBanner/ContentBanner';
import { ContentWhat } from './ContentWhat/ContentWhat';
import { ContentWeOfferV2 } from './ContentWeOfferV2/ContentWeOfferV2';
import { ExtraContent } from './ExtraContent/ExtraContent';

export const ContentV2 = ({ data }) => {
  return (
    <div className="flex flex-col  gap-y-24">
      {data.title && (
        <ContentHeading
          title={data.title}
          description={data.description}
          image={data.image}
        />
      )}

      {!!data.offer_data.length && (
        <ContentWeOfferV2 title={data.offer_title} items={data.offer_data} />
      )}

      {(data.banner_title || data.banner_description) && (
        <ContentBanner
          title={data.banner_title}
          description={data.banner_description}
          withButton={!!data.banner_with_button}
          bookServiceButton={!!data.bookServiceButton}
        />
      )}

      {!!data.why_title && (
        <ContentWhat
          title={data.why_title}
          description={data.why_description}
          items={data.why_items}
          footerText={data.why_footerText}
        />
      )}

      {!!data?.extraContent?.length && (
        <ExtraContent data={data.extraContent} />
      )}
    </div>
  );
};
